export enum TokensPaymentEnum {
    STRIPE,
    GOOGLE_PAY,
    APPLE_PAY,
}
